import { Component, OnDestroy} from "@angular/core";
import { Input } from "@angular/core";

import * as moment from "moment";
import * as tz from "moment-timezone";
import "moment-timezone/builds/moment-timezone-with-data-2012-2022.js";

@Component({
    selector: "time-ctrl",
    template: require('./time.ctrl.html'),
    styles: [require('./time.ctrl.css')]
})

export class TimeControl implements OnDestroy {

    public value : string="";

    @Input()
    public timeZone : string="America/New_York";

    // https://momentjs.com/docs/#/displaying/
    @Input()
    public format : string="HH:mm:ss";

    @Input()
    public label : string="New York";

    @Input()
    public flagCode : string="ad";

    private _timer: any=null;

    constructor() {

        this._timer=setInterval(()=> {
            let v: moment.Moment =moment();
            this.value=v.tz(this.timeZone).format(this.format);
        },500);
    }

    ngOnDestroy (): void {
        clearInterval(this._timer);
    }
}